export { default as ShipmentInfoList } from './ShipmentInfoList';



// WEBPACK FOOTER //
// ./src/modules/shipment-info/pages/index.js